import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseAuthenticationService, RouterService } from '@app/core';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { addIcons } from 'ionicons';
import {
  calendarOutline,
  checkmarkCircleOutline,
  close,
  mailOutline,
} from 'ionicons/icons';

@Component({
  selector: 'app-account-required',
  templateUrl: './account-required.component.html',
  styleUrls: ['./account-required.component.scss'],
  imports: [
    IonHeader,
    IonContent,
    IonButton,
    IonButtons,
    IonToolbar,
    IonIcon,
    TranslocoPipe,
    IonFooter,
  ],
})
export class AccountRequiredComponent {
  constructor(
    private readonly modalController: ModalController,
    private readonly routerService: RouterService,
    private readonly firebaseAuthenticationService: FirebaseAuthenticationService,
    private readonly router: Router,
  ) {
    addIcons({
      close,
      mailOutline,
      calendarOutline,
      checkmarkCircleOutline,
    });
  }

  public dismiss() {
    this.modalController.dismiss();
  }

  public async onNavigateToRegisterPage(): Promise<void> {
    // Preserve the current URL (checkout page) so user can return after authentication
    const currentUrl = this.router.url;
    if (
      currentUrl &&
      !currentUrl.includes('/register') &&
      !currentUrl.includes('/login')
    ) {
      this.firebaseAuthenticationService.redirectUrl = currentUrl;
    }

    await this.routerService.navigateToRegisterPage();
    this.dismiss();
  }
}
